/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VideoFile/view.blocks to change it.
import Canvas from 'DesignSystem/Canvas/react'
import FrameGrabs from './FrameGrabs/index'
import Player from './Player/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VideoFile({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/VideoFile"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="VideoFile.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="VideoFile.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Player
  viewPath={`${viewPath}/Player`}
/>
</div>
<FrameGrabs
  viewPath={`${viewPath}/FrameGrabs`}
/>
<Canvas
  viewPath={`${viewPath}/Canvas`}
/>
</div>
{children}
</React.Fragment>)
}